import React, { useContext } from 'react';
import "./certification.css";
import Component from './Component';
import DataContext from '../../../../DataContext';
import DButton from '../../../Utilities/DButton';

const Certification = ({ limit = null, showMore = false }) => {
  const { certs } = useContext(DataContext);

  const isLoading = !certs || certs.length === 0;
  const displayCerts =
    !isLoading && typeof limit === 'number' ? certs.slice(0, limit) : certs;

  return (
    <section className='certification page-wrap'>
      <div className="cmd">
        <span className="prompt">$</span> cat ~/certs
      </div>
      <div className="d-title">Certifications</div>

      {isLoading ? (
        <div className="d-text loading">Loading...</div>
      ) : (
        <div className="card-grid">
          {displayCerts.map((item) => (
            <Component
              key={item.id}
              exam={item.data.title}
              time={item.data.date || item.data.placement || "No Date"}
            />
          ))}
        </div>
      )}

      {!isLoading &&
        showMore &&
        certs.length > displayCerts.length && (
          <div className="show-more fcs">
            <DButton text="all certifications →" to="/certifications" />
          </div>
        )}
    </section>
  );
};

export default Certification;
